import ProductCard from "./ProductCard";

export default function ProductGrid({ products, showBuyNow = false }) {
  if (!products.length) {
    return <div className="reveal mx-4 sm:mx-5 md:mx-10 bg-white p-6 sm:p-10 rounded-2xl sm:rounded-3xl shadow-soft text-center">Ürün bulunamadı.</div>;
  }

  return (
    <section className="px-4 sm:px-5 md:px-10 py-6 sm:py-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 lg:gap-8">
      {products.map((p) => <ProductCard key={p.id} product={p} showBuyNow={showBuyNow} />)}
    </section>
  );
}
